import BaseService from '@/service/modules/BaseService'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import axios from '@/axios'
import CompanyInfo from '@/model/modules/CompanyInfo'

export default class CompanyService extends BaseService {
  protected static baseUrl: string = '/company'

  public static list(example: { [index: string]: any }, pageNum: number, pageSize: number): Promise<BasePageableInfo<CompanyInfo>> {
    example.page = pageNum
    example.size = pageSize
    return new Promise<BasePageableInfo<CompanyInfo>>((resolve, reject) => {
      axios.get(this.baseUrl + '/company-list', {
        params: example
      }).then(resp => {
        const result: BasePageableInfo<CompanyInfo> = new BasePageableInfo()
        result.count = resp.data.body.totalElements
        result.dataList = resp.data.body.content
        resolve(result)
      })
    })
  }
}
